import React, {Component} from "react";
import * as R from "ramda";
import {removeNullFields} from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import {yearOptions} from "../../config";
import {configTableMonthlyMonitoring, sellTypeOptions} from "../config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import CardBartChart from "../../../../../cards/SimpleBarchart";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";
import {service} from "../service";
import {fetchDataAsync} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {HttpStatus} from "../../../../common/Constants";
import {defaultTableChange} from "../../../../../modules/custom/customTable";

const rupiahFormatter = (v) =>
  `${Number(v || 0).toLocaleString("id-ID")}`;
class MonitoringMonthlyUnitProfit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            sellType: null,
            chartVisible: false,
            barVisible: true,
            lineVisible: false,
            dataTable: [],
            dataChart: [],
            dataKey: [],
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
          ...prevValue,
          year: yearOptions.find(
            (item) => item.value === currentDate.getFullYear()
          ),
        }));
      }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(R.sortBy(R.identity, prevProps.listCabang), R.sortBy(R.identity, this.props.listCabang))) {
            this.setState((prevValue) => ({...prevValue, dataTable: []}));
        }
    };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    fetchData = async () => {
        this.props.triggerLoading();
        let {year, sellType} = this.state;
        let {listCabang} = this.props;
        const request = removeNullFields({
            listKodeCabang: listCabang,
            year: year?.value,
            listPaymentMethod: R.isNil(sellType)
                ? []
                : sellType?.value === "ALL"
                    ? ["CASH", "CREDIT"]
                    : [sellType?.value],
        });
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT_DTO").getDataProfitUnitMonthlyAccounting,
            menuName: "Dashboard Akunting - Monitoring Profit Unit Bruto Rata-Rata By Tipe Per Bulan",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                dataChart: service.parseDataChart(res.data.data),
                dataKey: service.parseDataKey(res.data.data),
            }));
        }
        this.props.triggerLoading();
    };

    handleChartVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            chartVisible: !prevValue.chartVisible,
        }));
    };

    switchBarAndLineChart = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            barVisible: !prevValue.barVisible,
            lineVisible: !prevValue.lineVisible,
        }));
    };

    render() {
        let {dataTable, dataChart, dataKey, year, sellType, chartVisible, barVisible, lineVisible} = this.state;
        return (
            <>
                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        isClearable
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        options={yearOptions}
                        value={year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}

                    />
                    <SimpleDDL
                        id="select_options_sell_type"
                        box="search"
                        name="sellType"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Type Jual"
                        options={sellTypeOptions}
                        value={sellType}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        text="Cari"
                        className="margin-bottom-15px"
                        onClick={this.fetchData}
                    />
                </FlexView>
                <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                    MONITORING PROFIT UNIT BRUTO RATA-RATA BY TYPE PER BULAN
                </p>
                {!chartVisible && (
                    <SimpleDataTable
                        data={dataTable}
                        columns={configTableMonthlyMonitoring}
                        rowsPerPage={5}
                        page={0}
                        options={{...defaultTableChange, serverSide: false}}
                    />
                )}
                {(chartVisible && barVisible) && (
                    <CardBartChart
                        data={dataChart}
                        dataKey={dataKey}
                        yAxisFormatter={rupiahFormatter}
                    />
                )}
                {(chartVisible && lineVisible) && (
                    <CardBiaxialChart
                        data={dataChart}
                        dataKey={dataKey}
                        yAxisFormatter={rupiahFormatter}
                    />
                )}
                <FlexView style={{justifyContent: "end", gap: "15px", marginTop: "15px"}}>
                    <SimpleButton
                        text="Chart"
                        className="margin-bottom-15px"
                        onClick={this.handleChartVisibility}
                    />
                    {chartVisible && (
                        <SimpleButton
                            text="Bar/Line"
                            className="margin-bottom-15px"
                            onClick={this.switchBarAndLineChart}
                        />
                    )}
                </FlexView>
            </>
        );
    }
    ;
}

export default MonitoringMonthlyUnitProfit